export enum ShareCertificateOptions {
    INDIVIDUAL = 'individual share',
    REQUEST_CONFIRMATION = 'request confirmation'
}